<template>
  <div v-if="isShow()" id="duplicate">
    <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#post-duplicate-modal">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-copy"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667l0 -8.666" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
    Копия
  </button>
  <div class="modal modal-blur fade" id="post-duplicate-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Копия поста</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="card-body">
            <div class="row g-3">
              <div class="col-lg-4" v-for="channel of getChannels()" :key="channel.name_id">
                <div class="row g-3 align-items-center channel-link pb-2" @click.prevent="onClick(channel.name_id)">
                    <span class="col-auto">
                      <span class="avatar br-4" :style="{ backgroundImage: 'url(/assets/static/channels/' + channel.img + ')' }"></span>
                    </span>
                  <div class="col text-truncate">
                      <span class="text-reset d-block text-truncate">
                        {{ channel.name }}
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import {useRouter} from "vue-router";
import PostPermission from "@/modules/post/services/Permission";

export default defineComponent({
  name: "Duplicate",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    let show = ref(false)

    const fields = reactive({
      postId: "",
    })

    watch(() => props.payload, (val) => {
      updateFields(val)
    }, {
      immediate: true,
    })

    function updateFields(query) {
      fields.postId = query.post_id
    }

    onMounted(async () => {
      markUnshow()
      markShow()
    })

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    const router = useRouter()

    let closeModal = ref(null)

    let channels = [
      {
        name: "Молния",
        name_id: 3,
        img: "molniya.jpg",
      },
      {
        name: "Aliexpress",
        name_id: 4,
        img: "ali.jpg",
      },
      {
        name: "Халявщики",
        name_id: 2,
        img: "hlv.jpg",
      },
      {
        name: "Travel",
        name_id: 7,
        img: "travel.jpg",
      },
      {
        name: "Live",
        name_id: 9,
        img: "live.jpg",
      },
      {
        name: "Нашли дешевле",
        name_id: 8,
        img: "cheaper.jpg",
      },
      {
        name: "DailySales",
        name_id: 5,
        img: "daily.jpg",
      },
      {
        name: "Эконом",
        name_id: 10,
        img: "econom.jpg",
      },
      {
        name: "Haunt",
        name_id: 11,
        img: "haunt.jpg",
      },
      {
        name: "Ultima",
        name_id: 12,
        img: "ultima.jpg",
      },
    ]

    function getChannels() {
      return channels.filter((item) => {
        return PostPermission.isCreate(item["name_id"])
      })
    }

    function onClick(nameId) {
      let routeData = router.resolve({
        name: 'PostDuplicate',
        params: {
          channel_id: nameId
        },
        query: {
          post_id: fields.postId,
        }
      });

      window.open(routeData.href, '_blank');

      closeModalWindow()
    }

    function closeModalWindow() {
      closeModal.value.click()
    }

    return {
      isShow,
      getChannels,
      onClick,
      closeModal,
    }
  }
})
</script>

<style src="./css/style.css"></style>
